import React, { useEffect, useState } from 'react';
import { useSwipeable } from 'react-swipeable'

import { IProduct } from '@interfaces';
import Clickable from '@v2/components/common/presentational/clickables/default';

import styles from '@components/common/products/product.styles';
import { imgV2 as img } from '@styles/utils';
import { WPImage } from '@v2/utils/image';

export default function ProductFDA({ product }: { product?: IProduct }) {
    const [images, setImages] = useState([]);
    const [slide, setSlide] = useState(0);
    const maxSize = images.length;
    const swipeHandlers = useSwipeable({
        onSwipedLeft: () => slide < images.length - 1 ? setSlide(slide + 1) : {},
        onSwipedRight: () => slide > 0 ? setSlide(slide - 1) : {},
        delta: 10,
        //preventDefaultTouchmoveEvent: false,
        trackTouch: true,
        trackMouse: false,
        rotationAngle: 0,
    });

    useEffect(() => {
        let array: any[] = [];

        if (product.fdaImage) {
            array.push(product.fdaImage);
        }
        if (product.fdaSecondImage) {
            array.push(product.fdaSecondImage);
        }

        setImages(array);
    }, [product])

    return (
        <div className={`${styles.fda} fda-slider`}>
            {maxSize > 1 &&
                <div className="arrows">
                    <Clickable
                        onClick={() => setSlide(slide === 0 ? Object.keys(images).length - 1 : slide - 1)}
                        className={`left`}>
                        <img className={`arrow`} src={img('shop/arrow-left.svg')} alt={''} />
                    </Clickable>
                    <Clickable
                        onClick={() => setSlide((Object.keys(images).length - 1) === slide ? 0 : slide + 1)}
                        className={`right`}>
                        <img className={`arrow`} src={img('shop/arrow-right.svg')} alt={''} />
                    </Clickable>
                </div>
            }
            {maxSize > 0 &&
                <>
                    {images.map((image: string, index: number) =>
                        <div
                            key={index}
                            className="animate__animated animate__zoomOutToIn"
                            style={slide !== index ? {display: 'none'} : {}} {...swipeHandlers}>
                            <WPImage
                                src={image}
                                alt="" />
                        </div>
                    )}
                    {maxSize > 1 &&
                        <div className="dots">
                            {images.map((image: string, index: number) =>
                                <Clickable
                                    key={index}
                                    className={index === slide ? 'active' : ''}
                                    onClick={() => setSlide(index)}>
                                    .
                                </Clickable>
                            )}
                        </div>
                    }
                </>
            }
        </div>
    );
}
